<h2 mat-dialog-title>Download</h2>
<mat-dialog-content>

  <div style="display: flex; flex-direction: column; gap: 10px;">
    <div class="item" *ngIf="briefcase?.isShared" [cdkCopyToClipboard]="link.href" (click)="showCopyMessage()" >
      <div style="display: flex; flex-direction: row; align-items: center; gap: 5px;" #tooltip="matTooltip"
           matTooltip="Link copied to clipboard!"
           matTooltipPosition="right">
        <mat-icon>content_copy</mat-icon>
        <div>Copy Share Link</div>
      </div>
      <div style="width: 100%" (click)="$event.preventDefault(); linkInput.select()">
        <a target="_blank" style="display: none;" href="/download/{{briefcase.sharedId}}" #link>{{link.href}}</a>
        <input class="shared-download-link" style="border: none; outline: none; width: 100%;cursor: text; padding: 7px 0;" [ngModel]="link.href" [readOnly]="true" #linkInput >
      </div>
    </div>
    <div *ngFor="let file of fileList">
      <div class="item" *ngIf="file.type === 'outgoing-briefcase-zipped'" (click)="downloadFile(file)">
        <div style="display: flex; flex-direction: row; align-items: center; gap: 5px;">
          <mat-icon>folder_zip</mat-icon>
          <div>Download Zip</div>
        </div>
      </div>
    </div>
    <div class="item" *ngIf="shouldShowCreateZip" (click)="createZip()">
      <mat-icon>folder_zip</mat-icon>
      <div>Create Zip</div>
    </div>
  </div>

</mat-dialog-content>
<mat-dialog-actions style="place-content: stretch flex-end; align-items: stretch; flex-direction: row; box-sizing: border-box; display: flex;">
  <button mat-raised-button color="secondary" mat-dialog-close>Cancel</button>
</mat-dialog-actions>
